<template>
  <div
    class="
          candidate-log-messages-block
          d-flex flex-column
          align-start
          py-2
          pr-2
          py-md-3
          pr-md-3
        "
    :class="[
      'icon-successed',
      `icon-${message.eventType}`,
      $vuetify.breakpoint.mdAndUp ? 'candidate-log-messages-block-mdAndUp' : '',
      showReview ? 'full-height' : ''
    ]"
  >
    <div class="candidate-log-messages-block__header">
      <div class="candidate-log-messages-block__date mr-5 caption">
        <div class="candidate-log-messages-block__date_time d-inline-block">
          {{ timeFormatted }}
        </div> <i>|</i> <div class="candidate-log-messages-block__date_date d-inline-block">
          {{ dateFormatted }}
        </div>
      </div>
      <div
        class="candidate-log-messages-block__content pt-md-1"
        :class="{ 'candidate-log-messages-block__content-mdAndUp' : $vuetify.breakpoint.mdAndUp }"
      >
        <div v-if="message.type === logType.ONLINE_INTERVIEW">
          <div
            class="d-inline-flex cursor-pointer align-center"
            @click="showOnlineInterviewWithQuestion"
          >
            <VIcon small color="grey">
              {{ openCut ? mdiEmailOpen : mdiEmail }}
            </VIcon>
            <div class="caption ml-1 primary--text pseudo-link">
              {{ $t('questionNumber') }}{{ questionIndex + 1 }}
            </div>
            <VIcon small color="primary">
              {{ openCut ? mdiMenuUp : mdiMenuDown }}
            </VIcon>
          </div>
          <div v-show="openCut" class="my-1 comment">
            {{ message.comment }}
          </div>
        </div>
        <div v-else-if="message.type === logType.OFFICE_INTERVIEW" class="d-flex">
          <div
            class="pseudo-link primary--text mr-2"
            @click="showOfficeInterviewPlayerWithTime"
          >
            {{ timestamp }}
          </div>
          <div v-linkify class="comment" v-html="message.comment" />
        </div>
        <template v-else-if="message.eventType === candidateLogType.COMMENT">
          <span v-linkify class="comment" v-html="message.comment" />
        </template>
        <CandidateLogMessageSendBlock
          v-else-if="message.eventType === candidateLogType.MESSAGE_SENT"
          :message="message"
        />
        <template v-else-if="message.eventType === candidateLogType.IMPORTED">
          <span v-linkify class="comment" v-html="message.comment" />
        </template>
        <template v-else-if="message.eventType === candidateLogType.AI_PROCESSING_READY">
          <div>{{ $t('ai_processing_ready') }}</div>
          <div v-if="message.comment">
            <div
              class="candidate-log-messages-block__content_link"
              @click="openCutAiProcessing = !openCutAiProcessing"
            >
              {{ openCutAiProcessing ? $t('hide') : $t('show') }}
            </div>
          </div>
        </template>
        <template v-else-if="message.eventType === candidateLogType.STATUS_CHANGED">
          {{ $t(message.eventType, { status: message.comment }) }}
        </template>
        <template
          v-else-if="message.eventType === candidateLogType.AI_INTERVIEW_REVIEW_READY
            && transcriptions && isAiRating && isAiReview"
        >
          <div>
            {{ $t('ai_interview_review_ready') }}
          </div>
          <div>
            <div v-if="showReview" class="candidate-log-messages-block__content_link" @click="changeShowReview">
              {{ $t('hide') }}
            </div>

            <div v-else class="candidate-log-messages-block__content_link" @click="changeShowReview">
              {{ $t('show') }}
            </div>
          </div>
        </template>
        <template v-else>
          <template
            v-if="message.eventType !== candidateLogType.COVER_LETTER"
            class="mb-3"
          >
            {{ event }}
          </template>
          <div v-if="message.eventType === candidateLogType.DECLINED_REASON">
            <div v-linkify class="my-1 comment" v-html="message.comment" />
          </div>
          <div v-if="message.eventType === candidateLogType.REFUSED || message.eventType === candidateLogType.COVER_LETTER">
            <div
              v-if="message.comment"
              class="d-inline-flex cursor-pointer align-center"
              @click="openCut = !openCut"
            >
              <VIcon small color="grey">
                {{ openCut ? mdiEmailOpen : mdiEmail }}
              </VIcon>
              <div class="caption ml-1 primary--text pseudo-link">
                {{ message.eventType === candidateLogType.REFUSED || message.eventType === candidateLogType.DECLINED ? $t('reason') : $t('coverLetter') }}
              </div>
              <VIcon small color="primary">
                {{ openCut ? mdiMenuUp : mdiMenuDown }}
              </VIcon>
            </div>
            <div
              v-show="openCut"
              v-linkify
              class="my-1 comment"
              v-html="message.comment"
            />
          </div>
        </template>
      </div>
    </div>
    <div v-if="showReview && message.eventType === candidateLogType.AI_INTERVIEW_REVIEW_READY" class="candidate-log-messages-block__review">
      <div class="ai-text-review mt-2" :class="{ 'maxHeight': isShowFull}">
        {{ candidate.interview.aiReview }}
      </div>
      <div v-if="reviewLength >= 150" class="read-full" @click="showFull">
        <template v-if="!isShowFull">
          {{ $t('showFull') }}
        </template>

        <template v-else>
          {{ $t('hide') }}
        </template>
      </div>
    </div>
    <div
      v-if="openCutAiProcessing && message.eventType === candidateLogType.AI_PROCESSING_READY && message.comment"
      class="candidate-log-messages-block__review"
    >
      <div class="ai-text-review mt-2 maxHeight">
        <div v-linkify v-html="message.comment" />
      </div>
    </div>
    <div
      v-if="candidateAdditionalFieldsInfo && message.eventType === candidateLogType.CANDIDATE_ADDITIONAL_FIELDS"
      class="candidate-log-messages-block__add-fields"
    >
      <div
        v-for="(field, index) in candidateAdditionalFieldsInfo"
        :key="index"
        class="pt-1 caption grey--text darken-1--text"
      >
        <span class="black--text text-body-2">{{ field.label }}:</span>
        <div>{{ field.value }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import linkify from 'vue-linkify';
import {
  mdiMenuUp, mdiMenuDown, mdiEmailOpen, mdiEmail, mdiDownload,
} from '@mdi/js';
import {
  toRefs, ref, computed, watch,
} from '@vue/composition-api';
import { logType, interviewType, candidateLogType } from '../../enums';
import { format } from '../../date-utils';
import { readableSeconds } from '../../functions';
import CandidateLogMessageSendBlock from './CandidateLogMessageSendBlock.vue';

export default {
  name: 'CandidateLogMessagesBlock',
  components: {
    CandidateLogMessageSendBlock,
  },
  directives: { linkify },
  props: {
    vacancy: {
      type: Object,
      required: true,
    },
    message: {
      type: Object,
      required: true,
    },
    candidate: {
      type: Object,
      required: true,
    },
    showReview: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, { emit }) {
    const { candidate, showReview, vacancy } = toRefs(props);
    const isShowFull = ref(false);

    const isAiRating = computed(() => (candidate.value.interview.aiRating === 0 ? true : !!candidate.value.interview.aiRating));
    const isAiReview = computed(() => !!candidate.value?.interview?.aiReview);

    const transcriptions = computed(() => candidate.value?.interview?.timestamps?.some(i => i.transcription !== null));

    const isTranscriptions = computed(() => candidate.value?.interview?.timestamps?.filter(i => i.transcription));

    const reviewLength = computed(() => candidate.value?.interview?.aiReview.split(' ').join('').length || 0);
    const candidateFullName = computed(() => `${candidate.value.firstName} ${candidate.value.lastName}`);

    const candidateAdditionalFields = computed(() => candidate.value?.additionalFields);
    const candidateAdditionalFieldsInfo = computed(() => (vacancy.value.candidateAdditionalFields
      ? vacancy.value.candidateAdditionalFields.map(item => ({
        label: item.label,
        value: candidateAdditionalFields.value[item.value],
      }))
      : []));
    function changeShowReview() {
      emit('change-active-tab');
    }

    function showFull() {
      isShowFull.value = !isShowFull.value;
    }

    watch(() => showReview, () => {
      if (showReview.value) {
        isShowFull.value = true;
      }
    });

    return {
      isShowFull,
      showFull,
      reviewLength,
      isAiRating,
      isAiReview,
      transcriptions,
      isTranscriptions,
      candidateFullName,
      changeShowReview,
      candidateAdditionalFieldsInfo,
    };
  },
  data() {
    return {
      candidateLogType,
      logType,
      openCut: false,
      openCutAiProcessing: false,
      mdiMenuDown,
      mdiMenuUp,
      mdiEmail,
      mdiEmailOpen,
      mdiDownload,
    };
  },
  computed: {
    dateFormatted() {
      return format(new Date(this.message.createdAt), 'd.MM');
    },
    timeFormatted() {
      return format(new Date(this.message.createdAt), 'HH:mm');
    },
    timestamp() {
      return readableSeconds(this.message.timestamp);
    },
    event() {
      if (this.message.eventType === candidateLogType.COMMENT) {
        return null;
      }
      return this.$t(this.message.eventType);
    },
    questionIndex() {
      const index = this.vacancy.script.questions
        .findIndex(q => q.id === this.message.questionId && q.type === this.message.questionType);

      if (index === -1) {
        return null;
      }

      return index;
    },
  },
  methods: {
    showOnlineInterviewWithQuestion() {
      this.openCut = !this.openCut;

      if (this.questionIndex === null || !this.openCut) {
        return;
      }

      this.$store.commit('candidatePage/setActiveInterviewType', interviewType.ONLINE_INTERVIEW);
      this.$store.commit('candidatePage/setActiveQuestion', this.questionIndex);
    },
    showOfficeInterviewPlayerWithTime() {
      this.$store.commit('candidatePage/setActiveInterviewType', interviewType.OFFICE_INTERVIEW);
      this.$store.commit('candidatePage/setOfficeInterviewPlayerTime', this.message.timestamp);
    },
  },
};
</script>

<style lang="scss" scoped>
.candidate-log-messages-block {
  padding-left: 40px;
  line-height: 1.43em;
  color: #212121;
  border-bottom: 1px solid #E2E2E2;
  background-repeat: no-repeat;
  background-position: 5px 7px;
  word-break: break-word;

  &.icon-invited {
    background-image: url(~@/assets/img/candidate/log/icons/invited.svg);
  }
  &.icon-successed {
    background-image: url(~@/assets/img/candidate/log/icons/interviewed.svg);
  }
  &.icon-inoffice_interview {
    background-image: url(~@/assets/img/candidate/log/icons/inoffice_interview.svg);
  }

  &.icon-office_interview_passed {
    background-image: url(~@/assets/img/candidate/log/icons/office_interview_passed.svg);
  }
  &.icon-job_offer {
    background-image: url(~@/assets/img/candidate/log/icons/job_offer.svg);
  }
  &.icon-hired {
    background-image: url(~@/assets/img/candidate/log/icons/hired.svg);
  }
  &.icon-declined {
    background-image: url(~@/assets/img/candidate/log/icons/declined.svg);
  }
  &.icon-declined_reason {
    background-image: url(~@/assets/img/candidate/log/icons/comment.svg);
  }
  &.icon-refused {
    background-image: url(~@/assets/img/candidate/log/icons/refused.svg);
  }
  &.icon-cover_letter {
    background-image: url(~@/assets/img/candidate/log/icons/cover_letter.svg);
  }
  &.icon-comment {
    background-image: url(~@/assets/img/candidate/log/icons/comment.svg);
  }

  &.icon-online_interview {
    background-image: url(~@/assets/img/candidate/log/icons/comment.svg);
  }

  &.icon-office_interview {
    background-image: url(~@/assets/img/candidate/log/icons/comment.svg);
  }

  &.icon-online_interview_processing_failed {
    background-image: url(~@/assets/img/candidate/log/icons/declined.svg);
  }

  &.icon-office_interview_processing_failed {
    background-image: url(~@/assets/img/candidate/log/icons/declined.svg);
  }

  &.icon-status_changed {
    background-image: url(~@/assets/img/candidate/log/icons/comment.svg);
  }

  &.icon-interviewed {
    background-image: url(~@/assets/img/candidate/log/icons/hired.svg);
  }

  &.icon-ai_interview_review_ready {
    background-image: url(~@/assets/img/candidate/log/icons/ai.svg);
  }

  &.icon-ai_processing_ready {
    background-image: url(~@/assets/img/candidate/log/icons/ai.svg);
  }

  &.icon-interview_transcription_ready {
    background-image: url(~@/assets/img/candidate/log/icons/txt.svg);
  }

  &__content {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    font-weight: 400;
    &_link {
      text-decoration: underline;
      color: #0A82D9;
      cursor: pointer;
      white-space: nowrap;
      margin-left: 10px;
    }
  }

  &__header {
    display: flex;
    width: 100%;
  }
  &__review {
    margin-left: -50px;
    @media screen and (max-width: 960px) {
      margin-left: -33px;
    }
  }

  &__add-fields {
    margin-left: 99px;
    @media screen and (max-width: 599px) {
      margin-left: 80px;
    }
  }

  .candidate-log-messages-block__date {
    width: 80px;
    line-height: 28px;
    color: #757575;
    white-space: nowrap;
    @media screen and (max-width: 599px) {
      width: auto;
    }
    &_time {
      @media screen and (max-width: 599px) {
        display: none;
      }
    }

    i {
      font-style: normal;
      color: #c0c0c0;
      @media screen and (max-width: 599px) {
        display: none;
      }
    }
  }
}

.candidate-log-messages-block-mdAndUp {
  padding-left: 60px;
  background-position: 10px 11px;
}

.candidate-log-messages-block__content-mdAndUp {
  width: calc(100% - 90px);
  position: relative;

  .remove-comment {
    position: absolute;
    right: -10px;
    top: -3px;
    cursor: pointer;
    opacity: 0.5;

    &:hover {
      opacity: 1;
    }
  }
}

.full-height {
  height: 100%;
}

.maxHeight {
  max-height: 100% !important;
}

.ai-text-review {
  max-height: 60px;
  overflow: hidden;
  color: #212121;
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
}

.read-full {
  width: 100%;
  text-align: center;
  color: #0A82D9;
  font-size: 13px;
  font-weight: 400;
  line-height: 100%;
  text-decoration-line: underline;
  cursor: pointer;
  margin-top: 10px;
}

.comment {
  max-width: 365px;
}
</style>

<i18n locale="en" lang="yaml">
coverLetter: Cover letter
invited: The candidate was invited for an online interview.
self_invited: The candidate applied for the vacancy.
interviewed: The candidate completed an online interview.
test_started: The candidate has started testing.
test_finished: The candidate has completed the test.
inoffice_interview: The candidate was invited for an in-person.
office_interview_passed: The candidate completed an in-person.
job_offer: The candidate received a job offer.
hired: The candidate accepted a job offer.
declined: The candidate was rejected.
declined_reason: "Rejection reson:"
refused: Candidate refused to take online interview.
cover_letter: 'Cover letter:'
message_sent: Message sent.
status_changed: The candidate’s status changed to {status}.
following_invite_link: The candidate followed the invitation link.
online_interview_recording_started: The candidate started recording an online interview.
online_interview_processing_failed: >-
  The candidate completed the recording of an online interview, but we were unable to process the video.
  The information has been transferred to our technical department.
office_interview_processing_failed: >-
  We were unable to process the in-person interview video.
  The information has been transferred to our technical department.
reason: Reason
questionNumber: Comment on question №
video_call_created: A videocall was created.
video_call_stopped: The videocall is finished.
video_call_processing_failed: The videocall recording has failed.
uploaded_video_interview_created: A video with an interview has been uploaded.
uploaded_video_interview_processing_failed: Your video could not be processed.
uploaded_video_interview_ready: A video interview is ready for viewing.
watch: Watch it here
show: Show
showFull: Show in full
hide: Hide
move: Move
ai_interview_review_ready: Assessment and summary of the interview from AI are available
ai_processing_ready: Candidate auto-parsing is complete.
vacancy: Job
candidate: Candidate
evaluationCandidate: Evaluation of the candidate
evaluationCandidateAi: Evaluation of the candidate from AI
summaryInterview: Summary of the interview
candidate_additional_fields: Additional information about the candidate
tested: The candidate has passed the test.
</i18n>

<i18n locale="ru" lang="yaml">
coverLetter: Сопроводительное письмо
invited: Отправлено приглашение на онлайн-интервью.
self_invited: Кандидат откликнулся на открытую вакансию.
interviewed: Кандидат прошёл онлайн-интервью.
test_started: Кандидат начал тестирование.
test_finished: Кандидат завершил тестирование.
inoffice_interview: Кандидат приглашён на очное интервью.
office_interview_passed: Кандидат прошёл очное интервью.
job_offer: Кандидату сделано предложение о работе.
hired: Кандидат принял предложение о работе.
declined: Не готовы сделать предложение о работе.
declined_reason: "Причина отказа:"
refused: Кандидат отказался проходить онлайн-интервью.
cover_letter: 'Сопроводительное письмо:'
message_sent: Отправлено сообщение.
status_changed: Кандидат переведён в статус {status}.
following_invite_link: Кандидат перешел по ссылке из приглашения.
online_interview_recording_started: Кандидат начал запись онлайн-интервью.
online_interview_processing_failed: >-
  Кандидат записал онлайн-интервью, но, к сожалению, нам не удалось обработать видео.
  Информация передана в технический отдел, и мы сделаем все возможное,
  чтобы в будущем таких ошибок становилось меньше.
office_interview_processing_failed: >-
  К сожалению, нам не удалось обработать видео очного интервью.
  Информация передана в технический отдел, и мы сделаем все возможное,
  чтобы в будущем таких ошибок становилось меньше.
reason: Причина
questionNumber: Комментарий к вопросу №
video_call_created: Создан видеозвонок.
video_call_stopped: Видеозвонок закончен.
video_call_processing_failed: Не удалось обработать запись видеозвонка.
uploaded_video_interview_created: Видео с интервью загружено.
uploaded_video_interview_processing_failed: Не удалось обработать загруженное видео.
uploaded_video_interview_ready: Загруженное видео готово к просмотру.
watch: Посмотреть
show: Показать
showFull: Показать полностью
hide: Скрыть
move: Перейти
ai_interview_review_ready: Доступна оценка и резюме собеседования от ИИ
ai_processing_ready: Авторазбор кандидата окончен.
vacancy: Вакансия
candidate: Кандидат
evaluationCandidate: Оценка кандидата
evaluationCandidateAi: Оценка кандидата от ИИ
summaryInterview: Краткое содержание интервью
candidate_additional_fields: Дополнительная информация о кандидате
tested: Кандидат прошел тестирование.
</i18n>
